import {Button, ErrorMessage} from '_core'
import {ModalBody, ModalFooter, ModalHeader} from '_core/components/Modal'
import clsx from 'clsx'
import {FC, useState} from 'react'
import {Modal} from 'react-bootstrap'
import trim from 'lodash/trim'
import ActionButton from './ActionButton'

type Props = {
  showEmail: boolean
  title: string
  message: string
  onConfirm: (value: any) => void | any
  onClose: () => void
  isSubmitting: boolean
  description?: string
  subTitle?: string
  actionLabel?: string
  isRefundAndRestock?: boolean
}
const OrderActionConfirmationDialog: FC<Props> = ({
  showEmail,
  message,
  onConfirm,
  onClose,
  isSubmitting,
  title,
  description,
  subTitle,
  actionLabel,
  isRefundAndRestock,
}) => {
  const [actionState, setActionState] = useState({
    sendEmail: false,
    reason: '',
  })
  const [error, setError] = useState<string>('')
  const handleCheck = (e: any) => {
    const {checked} = e.target
    setActionState({...actionState, sendEmail: checked})
    setError('')
  }
  const handleReasonChange = (e: any) => {
    const {value} = e.target
    setActionState({...actionState, reason: value})
    setError('')
  }

  const validate = (value: string): boolean => {
    const length = value.length
    if (length === 0) {
      setError('Reason is required')
      return false
    }

    if (length < 10) {
      setError('Reason must be at least 10 characters')
      return false
    }

    if (length > 249) {
      setError('Reason should not exceed 250 characters')
      return false
    }
    setError('')
    return true
  }

  const handleSubmit = async () => {
    if (validate(trim(actionState.reason))) {
      await onConfirm(actionState)
    }
  }

  return (
    <Modal tabIndex={-1} aria-hidden='true' dialogClassName='h-auto' show onHide={onClose}>
      <ModalHeader title={title} toolbar={{onClick: onClose}} />
      <ModalBody>
        {actionLabel ? (
          <p className='fs-4'>
            <span className='fw-bolder'>{actionLabel}:</span> This action will manually change the
            order status without{subTitle} notifying the customer.
          </p>
        ) : (
          message && <p className='fs-4 mb-5'>{message}</p>
        )}
        <div className='mb-3'>
          <textarea
            id='txtReason'
            name='reason'
            className={clsx('form-control', error && 'is-invalid')}
            onChange={handleReasonChange}
            rows={5}
            maxLength={300}
            placeholder='Enter Reason'
          />
        </div>
        {showEmail && (
          <div className='d-flex align-items-center me-2 gap-3'>
            <div className='form-check form-check-custom form-check-solid form-check-primary me-6'>
              <input
                type='checkbox'
                className='form-check-input'
                id='selectAll'
                checked={actionState.sendEmail}
                onChange={handleCheck}
              />
            </div>

            <div className='flex-grow-1'>
              <h5 className='d-flex align-items-center flex-wrap pt-1'>Send Email</h5>
            </div>
          </div>
        )}
        <ErrorMessage error={error} />
        {description && <div className='fs-5 py-2'>{description}</div>}
      </ModalBody>
      <ModalFooter
        close={{
          id: 'btnCancel',
          text: 'No, Cancel',
          onClick: onClose,
          className: 'btn btn-secondary btn-sm ms-5',
        }}
      >
        <ActionButton
          isRefundAndRestock={isRefundAndRestock}
          currentState={actionState}
          onClose={onClose}
        >
          <Button
            id='btnSubmit'
            className='btn btn-primary btn-sm ms-5'
            type='button'
            onClick={handleSubmit}
            isSubmitting={isSubmitting}
            title='Yes, proceed'
          />
        </ActionButton>
      </ModalFooter>
    </Modal>
  )
}

export default OrderActionConfirmationDialog
